<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-ear'" :note="printNote" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">当センターを知ったきっかけ</v-list-item-subtitle>
      <v-list-item-title v-if="isPrintEmpty">当センターを知ったきっかけ</v-list-item-title>
      <v-list-item-title v-else-if="isNoAnswer">回答なし</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getKnowLabelItems" :key="idx" class="caption grey lighten-2 pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>当センターを知ったきっかけ</v-subheader>
    <v-row dense justify="end">
      <div class="text-xs-right">
        <v-switch color="blue darken-2" label="回答なし" v-model="config.ignore" @change="ignore"></v-switch>
      </div>
    </v-row>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" class="px-3">
        <span class="caption">知ったきっかけ</span>
        <v-chip-group multiple column
          active-class="secondary white--text"
          v-model="form.knows.content">
          <v-chip
            v-for="item in getKnowItems"
            :key="`knows_content_${item.value}`"
            :value="item.value"
            :rules="rules.knows">{{ item.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.knows.note"
          label="知ったきっかけの備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutSurveyKnows',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false
      },
      meta: {
        knows: {
          media: 'TV/ラジオ/CM等',
          magazine: 'タウン/情報誌',
          online: 'インターネット',
          newspaper: '新聞',
          school: '学校',
          sign: '看板を見て',
          friends: '知人の紹介',
          supporter: '留学サポーター',
          other: 'その他'
        }
      },
      form: {
        knows: {
          id: '',
          content: [],
          note: ''
        }
      },
      rules: {
        knows: [
          v => !!(v && v.length) || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.knows
      ) {
        this.$set(this.config, 'ignore', !!(this.$props.data.knows.content && this.$props.data.knows.content === 'NONE'))
        this.$set(this.form, 'knows', {
          id: '' + (this.$props.data.knows.id ? this.$props.data.knows.id : 'new_knows'),
          content: this.$props.data.knows.content ? this.$props.data.knows.content.split(',') : [],
          note: this.$props.data.knows.note ? this.$props.data.knows.note : ''
        })
      } else {
        this.$set(this.form, 'knows', {
          id: 'new_knows',
          content: [],
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'knows'
        }
      })
    },
    ignore: function () {
      this.$set(this.form.knows, 'content', this.config.ignore ? ['NONE'] : [])
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['knows', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'knows'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['knows', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'knows'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.knows &&
        this.$props.data.knows.content &&
        this.$props.data.knows.content === 'NONE'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.knows &&
        this.$props.data.knows.content
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.knows &&
        this.$props.data.knows.note
      ) ? this.$props.data.knows.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.knows &&
        this.$props.data.knows.note
      )
    },
    getKnowItems () {
      return Object.keys(this.meta.knows).map(key => {
        return {
          text: this.meta.knows[key],
          value: key
        }
      })
    },
    getKnowLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.knows &&
        this.$props.data.knows.content
      ) ? this.$props.data.knows.content.split(',').map(key => {
          return (this.meta.knows[key]) ? this.meta.knows[key] : ''
        }) : []
    }
  }
}
</script>
